import { Lightbulb } from 'lucide-react';

export default function IdeaSummary() {
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100vh-200px)]">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-gradient-to-br from-[#d4af37] to-[#b8941e] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
          <Lightbulb className="w-10 h-10 text-white" />
        </div>
        <h2 className="text-2xl font-semibold text-neutral-900 mb-3">Idea Summary</h2>
        <p className="text-neutral-500 text-sm leading-relaxed">
          This feature is coming soon. Track and manage all user ideas and feature requests in one place.
        </p>
      </div>
    </div>
  );
}
